import React, { PureComponent } from 'react';
import { Icon, Row, Col } from 'antd';
import { cloneDeep, get } from 'lodash';
import { LinkType, EffectiveTime, UploadPicture } from '../../tools';
import { LinkTypeMode } from '../../../types';

//图片广告位项
export class ImageAdItem extends PureComponent<{
    sourceRoot?: {
        image?: string;
    };
    items?: Array<any>;
    index?: number;
    onChange?: (value: any) => void;
    item?: any;
    uploadAction?: string;
    linkTypes?: Array<any>;
    linkTypeMode?: LinkTypeMode;
    effectiveTime?: { start: string; end: string };
    selector: any;
}> {
    state = {
        uploadLoading: false,
    };
    change = (item) => {
        const { items, index, onChange } = this.props;
        let newItems = cloneDeep(items);
        newItems.splice(index, 1, item);
        onChange(newItems);
    };

    changeEffectiveTime = (time) => {
        const { item } = this.props;
        this.change({ ...item, ...time });
    };

    onUpload = (path) => {
        const { item } = this.props;
        let newItem = cloneDeep(item);
        newItem.pic = path;
        this.change(newItem);
    };

    removeItem = () => {
        const { items, onChange, index } = this.props;
        let newValue = cloneDeep(items);
        newValue.splice(index, 1);
        onChange(newValue);
    };

    render() {
        const { item, linkTypes, linkTypeMode, uploadAction, selector, sourceRoot } = this.props;
        console.log('------image-ad-item------ props:', this.props);
        return (
            <Row className="entry-item">
                <Icon type="close" className="item-remove" title="移除" onClick={this.removeItem} />
                <Col className="entry-item-image" span={4}>
                    <UploadPicture
                        sourceRoot={sourceRoot}
                        value={item.pic}
                        uploadAction={uploadAction}
                        onChange={this.onUpload}
                    />
                </Col>
                <Col className="entry-item-content" span={19}>
                    <LinkType
                        selector={selector}
                        linkTypes={linkTypes}
                        linkTypeMode={linkTypeMode}
                        value={item}
                        onChange={this.change}
                    />
                    <EffectiveTime
                        value={{ effectiveTime: get(item, 'effectiveTime', null) }}
                        onChange={this.changeEffectiveTime}
                    />
                </Col>
            </Row>
        );
    }
}
